angular.module('wbDashboard').controller('PlansDetailFastmoneyControllerAurea', ['$scope', '$uibModal', '$filter', 'User', 'PlanService', 'Message', 'ThinkingService', function ($scope, $uibModal, $filter, User, PlanService, Message, ThinkingService) {

    PlanService.user.retrieveAutos();
    $scope.$watch(function() { return PlanService.user.getAutos(); }, function(autos) {
        $scope.autos = autos;
    });

    $scope.confirmFeatures.initial = function() {
        //check what's can be enabled, enable it, create array of edits to go through
        ThinkingService.open($scope, "fastmoney", {thinking:"Activating Fast Money Features", complete:"Fast Money Activated!"});
        var featureWatch = $scope.$watch('featureInit', function(featureInit) {
            if (featureInit) {
                angular.forEach($scope.featureInit, function(enabled, featureSlug) {
                    switch (featureSlug) {
                        case 'quickdeposit':
                            $scope.featureInit[featureSlug] = true;
                            break;
                        case 'flexibleautodeposits':
                            $scope.featureInit[featureSlug] = true;
                            break;
                    }
                });
                $scope.confirmFeatures().then(function() {
                    ThinkingService.close(false, "fastmoney");
                });

                //disable watcher
                featureWatch();
            }
        });

    };

    $scope.confirmFeatures.complete = function() {
        $scope.initPages = [];

        if ($scope.featureInit.flexibleautodeposits) {
            $scope.initPages.push('flexibleautodeposits');
        }

        $scope.finishEdit();
    };

    $scope.disablePlan.initial = function() {
        $scope.disablingPlan = true;
        if ($scope.planFeatures.flexibleautodeposits.enabled) {
            if ( $scope.autos &&
                   ($scope.autos.frequency === 'Weekly' && $scope.autos.frequency_weekday === "Monday")
                ||
                   ($scope.autos.frequency === 'Monthly' && angular.equals($scope.autos.frequency_dates,[1]))
            ) {
                //do nothing, this is what it needs to be
            } else {
                $scope.$state.go('base.plans.detail.plan.feature.detail.edit', {fslug: 'flexibleautodeposits', page: 'disable'});
                return false;
            }
        }

        angular.forEach($scope.featureInit, function(enabled, featureSlug) {
            $scope.featureInit[featureSlug] = false;
        });
    };

    $scope.finishEdit = function() {
        if ($scope.initPages.length) {
            $scope.$state.go('base.plans.detail.plan.feature.detail.edit', {fslug: $scope.initPages.shift()}, {location: "replace"});
        } else if ($scope.initPages.length === 0) {
            $scope.initPages = false;
            $scope.$state.go('base.plans.detail.plan');
        } else if ($scope.disablingPlan) {
            $scope.disablingPlan = false; //only need it to do this once
            $scope.$state.go('base.plans.detail.plan.disable');
        } else if ($scope.$stateParams.returnTo) {
            $scope.$state.go($scope.$stateParams.returnTo);
        } else {
            $scope.$state.go('base.funding.auto-deposit');
            // $scope.$state.go('base.plans.detail.plan.feature.detail', {location: "replace"});
        }
    };

}]);
